import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchJobList } from "./employerJobListAPI";

const initialState = {
  data: [],
  total: 0,
  loading: false,
  error: null,
};

export const fetchJobListAsync = createAsyncThunk(
  "JobList/fetch",
  async (params, { rejectWithValue }) => {
    try {
      // params can be either a page number (for backward compatibility) or an object with page and filters
      const requestParams = typeof params === 'number'
        ? { page: params }
        : params;

      const data = await fetchJobList(requestParams);
      const resp = data.response;

      return {
        jobs: resp.data,  // The array of job data
        totalJobs: resp.total,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const JobListSlice = createSlice({
  name: "JobList",
  initialState,
  reducers: {
    clearJobList: (state) => {
      state.data = [];
      state.total = 0;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
  },
});

export const { clearJobList } = JobListSlice.actions;
export const selectJobList = (state) => state.jobList.data.jobs;
export const selectJobListTotal = (state) => state.jobList.data.totalJobs;

export default JobListSlice.reducer;